import React, { Backdrop, CircularProgress } from "@mui/material"
import { LoaderProps } from "./LoaderProps"

export const Loader = ({ active }: LoaderProps) => {
    return <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={active}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
}